import React from "react";

const ArthrosamidFortius = () => {
	return (
		<>
			<section>
				<h1>Pre-Administration Patient Information</h1>
				<h2>Consent Form</h2>
				<h3>ARTHROSAMID</h3>
				<p>
					Consent for knee injection - Arthrosamid. By signing this document you
					are agreeing to proceed with an injection of: Arthrosamid
					(intra-articular polyacrylamide hydrogel +/- local anaesthetic).
				</p>

				<h4>INJECTION SITE</h4>
				<p>The injection site has been confirmed with your clinician.</p>

				<h4>BENEFITS OF THE INJECTION</h4>
				<p>The benefits of the injection include:</p>
				<ul>
					<li>Relief of knee pain</li>
					<li>Improvement of symptoms</li>
					<li>Reduction of swelling</li>
				</ul>

				<h4>RISKS OF THE PROCEDURE</h4>
				<p>
					Arthrosamid is a novel knee injection product with 2 years of data
					including the benefits and risks of injection. This has informed the
					following potential risks. However at this stage it is not possible to
					give accurate percentages of risk but adverse reaction reporting is
					very low:
				</p>
				<ul>
					<li>
						Allergic reaction - up to this point no allergic reactions have been
						reported but the injection of a product carries a theoretical risk
						of reaction
					</li>
					<li>
						Post injection pain - it is recommended to avoid strenuous exercise
						for up to 1 week after injection
					</li>
					<li>Injection site pain</li>
					<li>Joint swelling</li>
					<li>No improvement or worsening knee pain</li>
					<li>
						Infection - you will receive prophylactic antibiotics one hour prior
						to the procedure. Although this risk is very low and the injection
						is performed using aseptic technique, any breach of the skin over a
						joint can lead to a deep infection. If this is a concern then it is
						imperative to seek urgent medical attention
					</li>
					<li>
						Delay to surgery - some surgeons will delay knee surgery between 3-6
						months after a knee injection
					</li>
				</ul>
				<p>
					Arthrosamid is non-immunosuppressive and therefore there is no
					evidence to suggest that there is an increased risk of community
					acquired COVID-19 infection. However any intervention carries a small
					risk.
				</p>

				<h4>ALTERNATIVES TO THE PROCEDURE</h4>
				<p>
					I understand that the alternatives to the above procedure include:
				</p>
				<ul>
					<li>Simple analgesia (pain-killers)</li>
					<li>Steroid or hyaluronic acid injection</li>
					<li>Weight management</li>
					<li>
						Activity modification (reduced exercise / increased rest / avoidance
						of aggravating activities)
					</li>
					<li>Splintage where appropriate</li>
					<li>Physiotherapy exercises</li>
				</ul>
			</section>
		</>
	);
};

export default ArthrosamidFortius;
